
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Ţintuire',
	'find_label': 'Găsire',
	'findCancelLabel': 'Anulare',
	'sourcePaneLabel': 'Surse selectate',
	'sourcePaneContentLabel': 'Selectare sursă',
	'addDataDashboardCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date pe tabloul dumneavoastră de bord.',
	'addDataStoryCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date în povestea dumneavoastră.',
	'addDataCoachMarkTitle': 'Adăugare date',
	'selectSourcesText': 'Selectaţi şi adăugaţi o sursă de date pentru a construi %{app}.',
	'selectSourcesLabel': 'Selectare sursă',
	'errorSourcesTitle': 'A eşuat încărcarea arborelui de date',
	'errorLoadingDataSources': 'A apărut o eroare la încărcarea listei de seturi de date',
	'errorLoadingDataTree': 'A apărut o eroare la încărcarea arborelui',
	'dataSetPaneLastUpdated': 'Ultima actualizare: %{date}',
	'dataSourcePaneDateUnknown': 'Necunoscut',
	'moreTitle': 'Mai multe',
	'backLabel': 'Deplasare înapoi',
	'addDataSourceDialogTitle': 'Adăugare sursă de date',
	'addDataSourceDialogButtonLabel': 'Adăugare',
	'dlg_use': 'Utilizare',
	'dlg_RelinkDataSourceTitle': 'Înlocuire setul de date \'%{dataSourceName}\' cu ...',
	'propertiesDialogTitle': 'Proprietăţi',
	'missingDataSetData': 'Datele pentru acest set de date nu sunt disponibile. Reîmprospătaţi setul de date sau contactaţi-vă administratorul pentru accesul la sursă.',
	'errorLoadingSource': 'Nu s-au încărcat metadatele pentru \'%{sourceName}\'. Vă rugăm să vă contactaţi administratorul pentru detalii.',
	'errorMessageTitle': 'Eroare',
	'calculation_navigation_in_use': 'Ştergerea calculelor sau căilor de navigare invalidează toate vizualizările care fac referire la articolul şters. Sunteţi sigur că vreţi să ştergeţi?',
	'delete_confirm': 'Confirmare ştergere',
	'previewUnavailable': 'Tava de date şi filtrele globale nu sunt disponibile pentru acest tip de pachet.',
	'contextualGridTabName': 'Date vizualizare',
	'DATA_TRAY_no_data_text': '\'Aici vor apărea datele dumneavoastră.\'',
	'contextualGridMenuLabel': 'Meniu de date vizualizare',
	'contextualGridExport': 'Export',
	'nullValueText': 'Nul',
	'forecastDetailsTabName': 'Detalii statistice previziune',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Măsuri acurateţe',
	'forecastDetailsSmoothingCoefLabel': 'Parametri',
	'forecastDetailsDiagnostics': 'Diagnostice',
	'forecastDetailsForecastLabel': 'Previziune',
	'forecastDetailsStatusLabel': 'Stare',
	'forecastDetailsAccuracyPercentLabel': 'Acurateţe %',
	'forecastDetailsTrendLabel': 'Tendinţă',
	'forecastDetailsSeasonLabel': 'Sezonabilitate',
	'forecastDetailsSeasonalPeriodLabel': 'Perioadă sezonieră',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Conţinut lipsă',
	'forecastDetailsSeriesLengthLabel': 'Lungime serie',
	'forecastDetailsIgnoredPeriods': 'Perioade ignorate',
	'forecastDetailsTrendStrength': 'Putere tendinţă',
	'forecastDetailsSeasonalityStrength': 'Putere sezonabilitate',
	'forecastDetailsTimeDeltaUnit': 'Interval dată / oră',
	'forecastDetailsNotes': 'Note'
});
